// extracted by mini-css-extract-plugin
export var introCopy = "intro-copy-module--introCopy--3OQDL";